import clsx from 'clsx';
import { withTheme } from '../ThemeProvider/withTheme';
import { StyledCountTab, StyledTab } from './style';
import { CustomTabsProps } from './types';

const TabsComponent = ({
  size,
  className,
  items,
  children,
  type,
  classNameLabel = '',
  ...props
}: CustomTabsProps) => {
  return (
    <StyledTab
      size={size}
      indicator={{ align: 'center' }}
      items={items?.map(item => ({
        ...item,
        label: (
          <div className={clsx(`tab-label ${classNameLabel}`)}>
            {item.label}
            {item.count && (
              <StyledCountTab className="tab-label-count">{item.count}</StyledCountTab>
            )}
          </div>
        ),
      }))}
      className={clsx(type === 'capsule' && 'capsule-tab', className)}
      {...props}
    />
  );
};

export const Tabs = withTheme(TabsComponent) as React.FC<CustomTabsProps>;
